import { Link } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function ImpressumPage() {
  var { t, language } = useLanguage();
  var de = language === 'de';

  return (
    <div className="min-h-screen bg-background" data-testid="impressum-page">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16">
        <Button asChild variant="ghost" className="mb-8 text-muted-foreground hover:text-foreground" data-testid="back-to-home">
          <Link to="/">
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('auth.backToHome')}
          </Link>
        </Button>

        <h1 className="text-3xl sm:text-4xl font-black tracking-tight mb-12">
          {de ? 'Impressum' : 'Legal Notice (Impressum)'}
        </h1>

        <div className="space-y-10 text-[15px] leading-relaxed">
          <section>
            <h2 className="text-lg font-bold mb-3 uppercase tracking-wider text-primary">
              {de ? 'Verantwortlich für diese Website' : 'Responsible for this Website'}
            </h2>
            <p>
              Endrich Media Agency<br />
              Kemptpark 28<br />
              8310 Kemptthal, {de ? 'Schweiz' : 'Switzerland'}
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 uppercase tracking-wider text-primary">
              {de ? 'Marke' : 'Brand'}
            </h2>
            <p>
              {de
                ? '«Schoolpix» ist eine Marke der Endrich Media Agency. Alle Rechte vorbehalten.'
                : '"Schoolpix" is a brand operated by Endrich Media Agency. All rights reserved.'}
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 uppercase tracking-wider text-primary">
              {de ? 'Haftungsausschluss' : 'Disclaimer'}
            </h2>
            <p className="mb-3">
              {de
                ? 'Die Endrich Media Agency übernimmt keine Gewähr für die Richtigkeit, Vollständigkeit oder Aktualität der auf dieser Website veröffentlichten Informationen. Jede Haftung für materielle oder immaterielle Schäden, die aus dem Zugang zu, der Nutzung oder der Nichtnutzung der veröffentlichten Inhalte entstehen, ist ausgeschlossen, sofern kein vorsätzliches oder grob fahrlässiges Verhalten nachgewiesen wird.'
                : 'Endrich Media Agency makes no warranty as to the accuracy, completeness, or currency of the information published on this website. Any liability for material or immaterial damages arising from access to, use of, or inability to use the published content is excluded, unless there is evidence of wilful misconduct or gross negligence.'}
            </p>
            <p>
              {de
                ? 'Links auf Websites Dritter liegen ausserhalb des Verantwortungsbereichs der Endrich Media Agency. Der Zugriff auf solche Websites erfolgt auf eigenes Risiko.'
                : 'Links to third-party websites are outside the responsibility of Endrich Media Agency. Access to such websites is at the user\'s own risk.'}
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 uppercase tracking-wider text-primary">
              {de ? 'Urheberrecht' : 'Copyright'}
            </h2>
            <p>
              {de
                ? 'Alle auf schoolpix.media veröffentlichten Inhalte — insbesondere Fotografien, Texte und Grafiken — sind urheberrechtlich geschützt. Jede Nutzung ohne vorherige schriftliche Zustimmung der Endrich Media Agency ist untersagt.'
                : 'All content published on schoolpix.media — in particular photographs, texts, and graphics — is protected by copyright. Any use without the prior written consent of Endrich Media Agency is prohibited.'}
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 uppercase tracking-wider text-primary">
              {de ? 'Gerichtsstand' : 'Jurisdiction'}
            </h2>
            <p>
              {de
                ? 'Gerichtsstand und anwendbares Recht: Kanton Zürich, Schweiz.'
                : 'Place of jurisdiction and applicable law: Canton of Zurich, Switzerland.'}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
